import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, RadioGroup } from 'foundations-library/components'

const useStyles = makeStyles(() => ({
    title: {
        marginBottom: '40px'
    },
    instruction: {
        marginBottom: '15px'
    }
}))

/**
 * @param {object} props
 */
const NumberCampaignStep = (props) => {
    const classes = useStyles()

    const campaignSavedData = props.passData?.campaign_step
    const [selectedCampaign, setSelectedCampaign] = useState(
        campaignSavedData ? campaignSavedData.selectedCampaign?.csp_campaign_id : null
    )

    const invalid = selectedCampaign == null

    const radioItems = useMemo(
        () =>
            props.eligibleCampaigns.map((campaign) => ({
                value: campaign.csp_campaign_id,
                label: campaign.name
            })),
        [props.eligibleCampaigns]
    )

    const getSaveData = () => ({
        selectedCampaign: props.eligibleCampaigns.find(
            (campaign) => campaign.csp_campaign_id === selectedCampaign
        ) || null
    })

    useEffect(() => {
        if (props.saveId) {
            props.update({
                completed: true,
                gotoNext: true,
                saveData: getSaveData()
            })
        }
    }, [props.saveId])

    useEffect(() => {
        props.update({ disableNextButton: () => invalid })
    }, [invalid])

    return (
        <div>
            <Typography
                variant='h5'
                remoteConfigID='sms_enrollment_number_step_1_title'
                className={classes.title}
            />

            <Typography
                variant='body1'
                remoteConfigID='sms_enrollment_number_campaign_step_instruction'
                className={classes.instruction}
            />

            <RadioGroup
                vertical
                color='neutral'
                value={selectedCampaign}
                items={radioItems}
                onChange={setSelectedCampaign}
            />
        </div>
    )
}

NumberCampaignStep.propTypes = {
    passData: PropTypes.object,
    update: PropTypes.func,
    saveId: PropTypes.number,
    eligibleCampaigns: PropTypes.array
}

NumberCampaignStep.defaultProps = {
    passData: {},
    update: () => { /* no-op */ },
    saveId: null,
    eligibleCampaigns: []
}

export default NumberCampaignStep
